import controller from './master-address-update-dialog.controller';

export default {
  controller,
  template: require('./master-address-update-dialog.html')
};



// WEBPACK FOOTER //
// src/app/family-plan/master-address-update-dialog/master-address-update-dialog.component.ts